import React, {PropTypes as T} from 'react';
import basketActions from '../../../../actions/basket';
import translate from '../../../../utils/translate';
import withDevice from '../../../common/withDeviceHOC';
import Recaptcha from '../../../edp/recaptcha';
import Button from '../../../common/button';

import {ticketPriceTotal,
  ticketFeeString,
  ticketFeeSumForActiveAndGaSeats,
  addNameAndValueOfMandatoryUpsellsToFeeMessage,
  totalBasket, showUNOC} from './utils';

export class BasketRecap extends React.Component {
  static propTypes = {
    activeSeats: T.object,
    GASeats: T.object,
    moneyFormat: T.string,
    currency:    T.string,
    count:       T.number,
    isActive:    T.bool,
    isExpanded:  T.bool,
    prices:      T.array,
    showServiceFeeBreakdown: T.bool,
    reCaptcha:   T.shape({
      showRecaptcha:  T.bool,
      isEnabled:      T.bool,
      siteKey:        T.string,
      verifyEndpoint: T.string
    }),
    isMobile: T.bool
  };

  toggleShowTickets = () => {
    basketActions.toggleShowTickets();
  };

  buyTickets = () => {
    basketActions.prepareToBuy(this.props);
    // stop event being propgated
    return false;
  };

  onReCaptchaCompletion = () => {
    basketActions.hideRecaptcha();
    basketActions.buyTicket(this.props);
  };

  render () {
    if (this.props.count < 1) {
      return false;
    }

    const text = {
      ticketServiceFee: translate('ticketPriceInformationModule', 'TICKET_SERVICE_FEE'),
      serviceFeePrefix: translate('ticketPriceInformationModule', 'SERVICE_FEE_RANGE_PREFIX'),
      serviceFeeSuffix: translate('ticketPriceInformationModule', 'SERVICE_FEE_RANGE_SUFFIX'),
      and:              translate('eventInfoModule', 'AND'),
      currency:         this.props.currency
    };
    const {prices, activeSeats, GASeats, moneyFormat} = this.props;
    const feeSum = ticketFeeSumForActiveAndGaSeats(prices, activeSeats, GASeats);
    const feeString  = ticketFeeString(feeSum, text, moneyFormat);
    let feeMessage   = (feeString)
      ? `${text.serviceFeePrefix} ${feeString} ${text.serviceFeeSuffix}`
      : '';
    feeMessage = addNameAndValueOfMandatoryUpsellsToFeeMessage(feeMessage, this.props, text);

    if (!this.props.showServiceFeeBreakdown && feeMessage) {
      feeMessage = text.ticketServiceFee;
    }

    if (this.props.showUnocFee && totalBasket(this.props) && showUNOC(this.props)) {
      feeMessage += ` ${translate('ticketPriceInformationModule', 'UNOC_FEE_TEXT')}`;
    }

    let ticketCountLabel, toggleCount;

    const mainClassName = this.props.isActive ? 'basketrecap is-active' : 'basketrecap  ';
    let dataComponent = 'basketrecap-total';

    const labelClass = this.props.isExpanded ? 'basketrecap__total__label is-expanded' : 'basketrecap__total__label';

    if (this.props.isMobile) {
      dataComponent += '_mobile';
      ticketCountLabel = 'x' + this.props.count;
    }
    else {
      ticketCountLabel = translate('ismModule', 'TOTAL');
      toggleCount = `${translate('ismModule', 'TICKETS_LABEL')} (${this.props.count})`;
    }

    const totalCostMessage = `${ticketCountLabel} - ${ticketPriceTotal(this.props)}`;

    return (
      <div className={mainClassName} data-component="basketrecap">

        <div
          className="basketrecap__toggle"
          onClick={this.toggleShowTickets}
          role="button"
          tabIndex="0">

          <div className="basketrecap__toggle__total" data-component="basketrecap-toggle">

            <h3 data-component="basketrecap-ticket-count" className="basketrecap__toggle__count">
              {toggleCount}
            </h3>

            <h3 data-component={dataComponent} className="basketrecap__total__title">
              <div className={labelClass}>
                {totalCostMessage}
              </div>

              <div
                className="basketrecap__total__text--desktop"
                data-component="basketrecap-ticket-count">
                {feeMessage.trim()}
              </div>
            </h3>

          </div>

          <div
            className="basketrecap__total__text"
            data-component="basketrecap-ticket-count">{feeMessage.trim()}</div>
        </div>

        <div className="basketrecap__buycontainer">
          <Button cta onClick={this.buyTickets}
            className="basketrecap__buy"
            data-component="basketrecap-buy-button">
            <div className="basketrecap__buy__mobile">{translate('ismModule', 'BASKET_BUY_LABEL')}</div>
            <div className="basketrecap__buy__desk">{translate('ismModule', 'BASKET_BUY_TICKETS_LABEL')}</div>
          </Button>
        </div>

        {
          this.props.reCaptcha.showRecaptcha &&
          <Recaptcha verifyEndpoint={this.props.reCaptcha.verifyEndpoint}
            siteKey={this.props.reCaptcha.siteKey}
            onClose={basketActions.hideRecaptcha}
            onSuccess={this.onReCaptchaCompletion}
          />
        }
      </div>
    );
  }
}

export default withDevice(BasketRecap);



// WEBPACK FOOTER //
// ./frontend/react/components/edp/basket/recap/index.js